


export const descargarPDF = (data, nombreArchivo='error') => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isIOS) {
        // Lógica específica para iOS
        const reader = new FileReader();
        reader.onload = () => {
            const url = reader.result;
            window.open(url, '_blank');
        };
        reader.readAsDataURL(blob);
    } else {
        // Lógica para otros navegadores
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = nombreArchivo;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }
};
















export const descargarArchivo = (data, nombre='cotizacion') => {
    const uint8Array = new Uint8Array(data);
    const blob = new Blob([uint8Array], {type: 'application/pdf'});
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = nombre
    link.click()
}





export const descargarImagen = async(blob, nombre='imagen') => {
    const resp = await blob.blob();

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(resp);
    link.download = nombre;
    link.click();
};